module.exports = __webpack_public_path__ + "img/gcash.46a65fb.svg";